import { required } from "ra-core";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { BooleanInput } from "@/components/admin/boolean-input";
import { Create } from "@/components/admin/create";
import { DateTimeInput } from "@/components/admin/date-time-input";
import { Edit } from "@/components/admin/edit";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";
import { Card, CardContent } from "@/components/ui/card";

import { EVENT_KINDS } from "../common/constants";
import {
  formatPersonName,
  type PersonNameFields,
} from "../../atomic-crm/misc/personName";

const EventInputs = () => (
  <div className="flex flex-col gap-4">
    <TextInput source="title" validate={required()} />
    <div className="grid gap-4 sm:grid-cols-3 [&>*]:min-w-0 [&>*>*]:min-w-0">
      <SelectInput source="kind" choices={EVENT_KINDS} validate={required()} />
      <DateTimeInput source="start_at" validate={required()} />
      <DateTimeInput source="end_at" />
    </div>
    <BooleanInput source="all_day" />
    <TextInput source="location" />
    <TextInput source="description" multiline rows={3} />
    <div className="grid gap-4 sm:grid-cols-3 [&>*]:min-w-0 [&>*>*]:min-w-0">
      <ReferenceInput source="company_id" reference="companies">
        <AutocompleteInput
          label="resources.events.fields.company_id"
          optionText="name"
        />
      </ReferenceInput>
      <ReferenceInput source="contact_id" reference="contacts">
        <AutocompleteInput
          label="resources.events.fields.contact_id"
          optionText={(c: PersonNameFields) => formatPersonName(c)}
        />
      </ReferenceInput>
      <ReferenceInput source="deal_id" reference="deals">
        <AutocompleteInput
          label="resources.events.fields.deal_id"
          optionText="name"
        />
      </ReferenceInput>
    </div>
  </div>
);

const toIso = (data: Record<string, any>) => ({
  ...data,
  start_at: data.start_at ? new Date(data.start_at).toISOString() : null,
  end_at: data.end_at ? new Date(data.end_at).toISOString() : null,
});

export const EventCreate = () => (
  <Create
    resource="events"
    redirect={() => "calendar"}
    transform={toIso}
    className="mx-auto w-full max-w-3xl"
  >
    <Card>
      <CardContent>
        <SimpleForm
          className="max-w-none"
          defaultValues={{ kind: "meeting", all_day: false }}
        >
          <EventInputs />
        </SimpleForm>
      </CardContent>
    </Card>
  </Create>
);

export const EventEdit = () => (
  <Edit
    resource="events"
    redirect={() => "calendar"}
    mutationMode="pessimistic"
    transform={toIso}
    className="mx-auto w-full max-w-3xl"
  >
    <Card>
      <CardContent>
        <SimpleForm className="max-w-none">
          <EventInputs />
        </SimpleForm>
      </CardContent>
    </Card>
  </Edit>
);

export default {
  create: EventCreate,
  edit: EventEdit,
  recordRepresentation: "title",
};
